<template>
  <div class="scroll-top-container" ref="fixedScrollUpEl">
    <button @click="scrollToTop">
      {{ t("backToTop") }}<span class="m-cgg-icon--chevron-up"></span>
    </button>
  </div>
  <Transition name="fade">
    <div class="floating-scroll-top-container" v-show="scrollBtnVisible">
      <button @click="scrollToTop" class="m-cgg-icon--chevron-up"></button>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
const scrollBtnVisible = ref(false);
const fixedScrollUpEl = ref();

const { t } = useI18n();

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const checkScrollBtnVisibility = () => {
  scrollBtnVisible.value =
    window.scrollY > window.innerHeight &&
    window.scrollY + window.innerHeight < fixedScrollUpEl.value.offsetTop;
};

onMounted(() => {
  window.addEventListener("scroll", checkScrollBtnVisibility);
});

onUnmounted(() => {
  window.removeEventListener("scroll", checkScrollBtnVisibility);
});
</script>

<style lang="scss" scoped>
.scroll-top-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: $light-blue;
  padding: 16px 24px;

  button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: none;
    padding: 0;
    border: none;
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    color: $extra-dark-blue;
    font-family: "Nunito Sans";

    &:hover {
      color: $main-blue;
    }
  }
}

.floating-scroll-top-container {
  position: fixed;
  bottom: 64px;
  right: 0;

  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 50px;
    width: 50px;
    border: none;
    border-radius: 16px 0px 0px 16px;
    background: $light-blue;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      color: $white;
      background: $main-blue;
    }
  }
}

@include fade-transition(0.3);
</style>

<i18n lang="json">
{
  "pt": {
    "backToTop": "Voltar ao topo"
  }
}
</i18n>
